/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';

import styles from './HubHero.module.scss';

import { Breadcrumb } from '../Breadcrumb/Breadcrumb';
import type { HubHeroProps } from './HubHero.types';

export const HubHero = ({ breadcrumb, title, description, className, children }: HubHeroProps) => (
  <header className={cn(styles['hero'], className)}>
    <div className={styles['inner']}>
      <Breadcrumb items={breadcrumb} className={styles['crumb']} />

      <TitleBlock size="page" align="left" title={title} description={description} className={styles['titleBlock']} />

      {children}
    </div>
  </header>
);
